var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"minigames-tournament-label",class:{ 'minigames-tournament-label--mobile': _vm.isMobile }},[_c('span',{staticClass:"minigames-tournament-label__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',{staticClass:"minigames-tournament-label__value",class:{
      'minigames-tournament-label__value--accent': _vm.isAccent,
    }},[_vm._v(" "+_vm._s(_vm.value)+" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }